<span matSnackBarLabel data-testid="failure-snackbar">
  {{ data }}
</span>
<span matSnackBarActions>
  <button data-testid="close-error-snackbar-button" mat-button matSnackBarAction
          (click)="snackBarRef.dismissWithAction()"><mat-icon>close</mat-icon></button>
</span>
